export function removeIfNullUndefined(obj: any) {
    const clone = Object.assign({}, obj);
    Object.keys(clone).forEach((k) => (clone[k] === null || clone[k] === undefined) && delete clone[k]);
    return clone;
}